// Bitflag values, must match EP.Core.Database.Enums.RepresentativeTypes in EP.Service/EP.Database.
export enum RepresentativeTypes {
  Admin = 1,
  Support = 2,
  Sales = 4,
  SuperAdmin = 8,
}
